<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
    <v-dialog v-model="dialog" persistent id="createProject" width="400px" :fullscreen="$vuetify.breakpoint.xsOnly">
        <v-card>
            <v-card-title class="py-6">
                <div class="text-h6 text-sm-h4" style="word-break: break-word;">{{ language.t('CreateProject.createProject')
                }}
                </div>
                <v-spacer></v-spacer>
                <v-btn icon color="blue darken-1" @click="$emit('close');">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-alert v-if="error" type="error" dismissible max-width="350px">{{ errorMessage }}</v-alert>
                <v-form ref="form" v-model="valid" lazy-validation v-on:submit.prevent="createProject">
                    <v-text-field v-model="form.projectName" :label="language.t('Forms.projectName')" :disabled="loading">
                    </v-text-field>
                    <p class="text-right">* = {{ language.t('Forms.requiredFields') }}</p>
                    <v-btn color="success" class="mr-4" type="submit" :disabled="!complete" :loading="saving">
                        {{ language.t('App.save') }}
                    </v-btn>
                </v-form>
            </v-card-text>
            <v-card-actions class="card-actions">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="$emit('close');">
                    <v-icon>mdi-close</v-icon>{{ language.t('App.close') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    components: {
    },
    props: {},
    data() {
        return {
            dialog: true,
            valid: true,
            loading: false,
            saving: false,
            succes: false,
            complete: true,
            error: false,
            errorMessage: null,
            form: {
                projectName: ""
            },
        };
    },
    mounted: function () {
    },
    computed: {},
    watch: {
    },
    methods: {
        createProject() {
            if (this.valid) {
                this.saving = true;
                this.error = null;

                this.$axios.post(route('api.projects.create', { projectName: this.form.projectName }))
                    .then((res) => {
                        console.log(res);
                        this.success = true;
                        this.saving = false;
                        this.$emit("update");
                        this.$emit("close");

                    })
                    .catch((error) => {
                        this.saving = false;
                        console.log(error.response.data);
                        if (error.response.data.message) {
                            this.error = true;
                            this.errorMessage = error.response.data.message;
                        } else {
                            this.error = true;
                            this.errorMessage = "__UNKNOWN_ERROR";
                        }
                    });
            }
        },
        close() {
            console.log(this);
            this.$emit("close");
        },
        onClose() {
            this.$emit("close");
        }
    },
};
</script>
<style scoped>
.v-alert__content {
    font-size: 12px;
}
</style>